import { ReactNode } from "react";
import { Modal, Button } from "@mui/material";
import { tss } from "tss-react/mui";
import { Close } from "@mui/icons-material";

const minHeight = 600;
const useStyles = tss.create(({theme}) => ({
    paper: {
        position: "absolute",
        width: 420,
        minHeight: minHeight,
        borderRadius: 4,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[4],
        padding: "15px 22px",
        border: `solid 1px ${theme.palette.divider}`,
        verticalAlign: "top",
        outline: "none"
    },
    button: {
        width: 15,
        height: 15,
        minWidth: 15,
    },
    closeButton: {
        position: "absolute",
        top: 10,
        right: 10,
        "& button": {
            color: theme.palette.text.disabled,
            "&:hover": {
                background: "none"
            }
        }
    },
    icon: {
        position: "relative",
        width: 24,
        height: 24,
        verticalAlign: "middle",
        display: "inline-block",
    },
    content: {
        display: "flex",
        flexDirection: "column",
        verticalAlign: "top",
    },
}));

type IProps = {
    open: boolean;
    width?: number;
    height?: any;
    minHeight?: any;
    paperStyle?: any;
    handleClose: () => void;
    children: ReactNode;
    onFocus?: () => void;
};

export default function ModalWindow(props: IProps) {
    const { classes } = useStyles();
    const { open, onFocus } = props;
    const body = (
        <div
            className={classes.paper}
            style={
                props.paperStyle
                    ? {
                          ...props.paperStyle,
                          width: props.width ? props.width : "",
                          height: props.height ? props.height : "",
                          minHeight: props.minHeight ? props.minHeight : minHeight,
                      }
                    : {
                          width: props.width ? props.width : "",
                          height: props.height ? props.height : "",
                          minHeight: props.minHeight ? props.minHeight : minHeight,
                      }
            }
        >
            <div className={classes.content}>
                {props.children}
                <div className={classes.closeButton}>
                    <Button
                        className={classes.button}
                        variant="text"
                        onClick={(e) => {
                            props.handleClose();
                        }}
                    >
                        <Close className={classes.icon} />
                    </Button>
                </div>
            </div>
        </div>
    );
    return (
        <div>
            <Modal
                open={open}
                onFocus={onFocus}
                onClose={props.handleClose}
                aria-labelledby="Create View"
                aria-describedby="Create View"
            >
                {body}
            </Modal>
        </div>
    );
}
